import "./DesktopSignupModal.scss";
import edit from "../../common/assets/svg/profileEdit.svg";
import { get, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DialCodePicker, { CountryCodeData } from "../dialCodePicker";
import { getCountryData } from "../../common/utils/country-data-util";
import countrycodedropdown from "../../common/assets/svg/dropdowncountrycode.svg";
import { updateProfileRequest } from "../../common/features/auth/AuthActions";
// import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
// import SignInForm from "../Signupnew/siginInContainer";
import { getCookie } from "../../helper/cookieHelper";
import { USER_DETAILS, USER_ID } from "../../common/constants";

interface DesktopSignupModalprops {
  isOpen?: boolean;
  onClose?: any;
  signInPopupDesktop?: boolean;
  setCurrentPage?: any;
  data?: any;
}
const DesktopSignupModal: React.FC<DesktopSignupModalprops> = ({
  isOpen,
  onClose,
  signInPopupDesktop,
  setCurrentPage,
  data,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      mobile: '',
      firstName: '',
      lastName: '',
      email: '',
    },
  });

  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const userCountry = useSelector((state: any) => state.auth?.countryCode);
  const emailDomains = ['.com', '@gmail.com', '@outlook.com', '@icloud.com', '@yahoo.com'];
  const dispatch = useDispatch();
  const [customTag, setCustomTag] = useState('');
  const [showOtherTag, setShowOtherTag] = useState(false);
  const [tags, setTags] = useState<string[]>([]);

  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const [countryData, setCountryData] = useState<CountryCodeData>(
    getCountryData(userCountry ? userCountry : '', restaurantDetails.country)
  );

  const customerDetails = getCookie(USER_DETAILS) || {};
  const customerName = customerDetails?.firstName || customerDetails?.name || "";
  const customerNumber = customerDetails?.mobilePhone;
  const customeremail = customerDetails?.email || "";
  const customerId = getCookie(USER_ID);

  useEffect(() => {
    if (customerNumber) {
      const number = customerNumber.split('-')[1];
      setValue('mobile', number);
    }
    if (customerName) {
      setValue('firstName', customerName);
    }
    if (
      customeremail ||
      (data?.inputData && restaurantDetails?.platformConfiguration?.sendOtpViaEmail)
    ) {
      if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
        setValue('email', data?.inputData);
      } else {
        setValue('email', customeremail);
      }
    }
  }, []);

  const handleDomainClick = (domain: string) => {
    const currentEmail = getValues('email') || '';

    let newEmail = currentEmail;

    if (domain.startsWith('@')) {
      const atIndex = currentEmail.indexOf('@');

      if (atIndex !== -1) {
        // Replace domain starting from '@'
        newEmail = currentEmail.slice(0, atIndex) + domain;
      } else {
        // Append '@domain' if no '@' exists
        newEmail = currentEmail + domain;
      }
    } else if (domain.startsWith('.')) {
      const atIndex = currentEmail.indexOf('@');

      if (atIndex !== -1) {
        const afterAt = currentEmail.slice(atIndex);
        const dotIndex = afterAt.indexOf('.');
        if (dotIndex !== -1) {
          // Replace from dot after '@'
          newEmail = currentEmail.slice(0, atIndex + dotIndex) + domain;
        } else {
          // No dot after @, just append domain
          newEmail = currentEmail + domain;
        }
      } else {
        // No '@', just append domain
        newEmail = currentEmail + domain;
      }
    }

    setValue('email', newEmail);
  };

  const UpdateProfileSuccess = useSelector((state: any) => state.auth.UpdateProfileSuccess);
  const updateUserDetailsSuccess = useSelector((state: any) => state.user.updateUserDetailsSuccess);
  const updateUserDetailsuseddata: string = useSelector(
    (state: any) => state.user.usedMobileorEmail
  );
  console.log({ updateUserDetailsuseddata });
  const watchedemail = watch('email');
  // console.log({watchedemail});

  const watchedponenumber = watch('mobile');

  console.log({ watchedponenumber });

  useEffect(() => {
    if (UpdateProfileSuccess || updateUserDetailsSuccess) {
      onClose();
    }
  }, [UpdateProfileSuccess, updateUserDetailsSuccess]);

  const onSubmit = (data: any) => {
    // Do not proceed if there are form validation errors
    if (errors?.firstName || errors?.lastName || errors?.mobile || errors?.email) {
      return;
    }

    // Block API call if current input matches a prior "linked" error condition
    const isMobileLinkedError =
      restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      UpdateProfileErrorMessage !== '' &&
      UpdateProfileErrorMessage?.includes('linked') &&
      updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}`;

    const isEmailLinkedError =
      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      UpdateProfileErrorMessage !== '' &&
      updateUserDetailsuseddata === watchedemail &&
      UpdateProfileErrorMessage?.includes('linked');

    if (isMobileLinkedError || isEmailLinkedError) {
      return;
    }

    const updateProfilePayload = {
      customerId: customerId && customerId !== 'undefined' ? customerId : '',
      mobilePhone: `${countryData.code}-${data.mobile}`,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      sendOtpViaEmail: restaurantDetails?.platformConfiguration?.sendOtpViaEmail,
    };
    dispatch(updateProfileRequest(updateProfilePayload));
  };

  const [isEdit, setIsEdit] = useState(false);
  const UpdateProfileErrorMessage = useSelector(
    (state: any) => state.auth.UpdateProfileErrorMessage
  );
  console.log({ UpdateProfileErrorMessage });

  const emailOtp = false;
  useEffect(() => {
    if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [restaurantDetails?.platformConfiguration?.sendOtpViaEmail]);

  return (
    //     <div className="container-Desktop-signup">

    //       <div className="modal-Desktop-signup">
    //                               <CancelIcon className="close-btnZa-Desktop-signup" onClick={onClose}/>
    //   {/* {
    //         !customerId  && <SignInForm isOpen={isOpen} onClose={onClose}  signInPopupDesktop={true}/>
    //       } */}

    //       </div>
    //     </div>
    <div>
      <div className="header-Desktop-signup">
        <h3 className="title-Desktop-signup">Sign up</h3>
        <p className="subtitle-Desktop-signup">
          Welcome, New user. Please enter your details to proceed.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="form-Desktop-signup">
        <div className="field-Desktop-signup mobile-container-D">
          <label>Mobile Number*</label>
          <div
            className="mobile-wrapper-Desktop-signup"
            style={{
              border:
                restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                UpdateProfileErrorMessage !== '' &&
                UpdateProfileErrorMessage?.includes('linked') &&
                updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}`
                  ? '1px solid #e52333'
                  : undefined,
              color:
                restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                UpdateProfileErrorMessage !== '' &&
                UpdateProfileErrorMessage?.includes('linked') &&
                updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}`
                  ? '#e52333'
                  : undefined,
            }}
          >
            <div className="countrycode-input-container-Desktop-signup">
              <div
                className="countryCodeContainer-Desktop-signup"
                onClick={() => setShowDialCodePicker(!showDialCodePicker)}
              >
                <img
                  src={countryData.flag}
                  height="24px"
                  width="24px"
                  className="flag-Desktop-signup"
                />
                <img src={countrycodedropdown} alt="" className="dropdown-icon-Desktop-signup" />
                <span className="codeText-Desktop-signup">{countryData.code}</span>
              </div>

              <span className="divider-Desktop-signup" />

              <input
                className="input-Desktop-signup"
                {...register('mobile', {
                  required: 'Mobile number is required',
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: 'Enter a valid 10-digit mobile number',
                  },
                })}
                style={{
                  color:
                    restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                    UpdateProfileErrorMessage !== '' &&
                    UpdateProfileErrorMessage?.includes('linked') &&
                    updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}`
                      ? '#e52333'
                      : undefined,
                }}
                maxLength={10}
                placeholder="(808) 555-0111"
                readOnly={!isEdit}
                type="text"
                inputMode="numeric"
                onKeyDown={e => {
                  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="dialCode">
            <DialCodePicker
              showPicker={showDialCodePicker}
              setShowPicker={setShowDialCodePicker}
              setCountrySelected={setCountrySelected}
              setCountryData={setCountryData}
              inputValue=""
              countryCode={customerNumber?.split('-')[0]}
              setIsMobile={true}
              onlyMobile={true}
              isMobileNot={true}
              width="50%"
              top="160px"
            />
          </div>

          {errors.mobile && <span className="error-Desktop-signup">{errors.mobile.message}</span>}

          {restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
            UpdateProfileErrorMessage !== '' &&
            UpdateProfileErrorMessage?.includes('linked') &&
            updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}` && (
              <span className="error-Desktop-signup">{UpdateProfileErrorMessage}</span>
            )}
        </div>

        <div className="name-fields-Desktop-signup">
          <div className="field-Desktop-signup">
            <label>First Name*</label>
            <input
              className="input-Desktop-signup"
              autoComplete="new-password"
              inputMode="text"
              onPaste={e => {
                const pastedText = e.clipboardData.getData('text');
                if (!/^[a-zA-Z]+$/.test(pastedText)) {
                  e.preventDefault();
                }
              }}
              onInput={e => {
                const input = e.target as HTMLInputElement;
                input.value = input.value.replace(/[^a-zA-Z]/g, '');
              }}
              onKeyDown={e => {
                const key = e.key;
                if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                  return;
                }
                e.preventDefault();
              }}
              maxLength={32}
              {...register('firstName', {
                required: 'First name is required',
                pattern: {
                  value: /^[A-Za-z]+$/,
                  message: 'Only alphabets allowed',
                },
              })}
              type="text"
            />
            {errors.firstName && (
              <span className="error-Desktop-signup">{errors.firstName.message}</span>
            )}
          </div>

          <div className="field-Desktop-signup">
            <label>Last Name</label>
            <input
              className="input-Desktop-signup"
              autoComplete="new-password"
              inputMode="text"
              onPaste={e => {
                const pastedText = e.clipboardData.getData('text');
                if (!/^[a-zA-Z]+$/.test(pastedText)) {
                  e.preventDefault();
                }
              }}
              onInput={e => {
                const input = e.target as HTMLInputElement;
                input.value = input.value.replace(/[^a-zA-Z]/g, '');
              }}
              onKeyDown={e => {
                const key = e.key;
                if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                  return;
                }
                e.preventDefault();
              }}
              maxLength={32}
              {...register('lastName')}
              // readOnly={!isEdit}
              type="text"
            />
            {errors.lastName && (
              <span className="error-Desktop-signup">{errors.lastName.message}</span>
            )}
          </div>
        </div>

        <div className="mail-field-Desktop-signup ">
          <label>Email*</label>
          <input
            className="input-Desktop-signup"
            style={{
              border:
                !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                UpdateProfileErrorMessage !== '' &&
                updateUserDetailsuseddata === watchedemail &&
                UpdateProfileErrorMessage?.includes('linked')
                  ? '1px solid #e52333'
                  : undefined,
              color:
                !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                UpdateProfileErrorMessage !== '' &&
                updateUserDetailsuseddata === watchedemail &&
                UpdateProfileErrorMessage?.includes('linked')
                  ? '#e52333'
                  : undefined,
            }}
            autoComplete="new-password"
            inputMode="text"
            type="text"
            readOnly={restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
            onPaste={e => {
              const pastedText = e.clipboardData.getData('text');
              if (!/^[a-zA-Z0-9@._%+-]$/.test(pastedText)) {
                e.preventDefault();
              }
            }}
            onKeyDown={e => {
              const key = e.key;
              if (
                key === 'Backspace' ||
                key === 'Delete' ||
                key === 'ArrowLeft' ||
                key === 'ArrowRight' ||
                key === 'Tab'
              ) {
                return;
              }
              const allowedChars = /^[a-zA-Z0-9@._%+-]$/;
              if (!allowedChars.test(key)) {
                e.preventDefault();
              }
            }}
            maxLength={32}
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: 'Enter a valid email',
              },
            })}
          />
          {errors.email && <span className="error-Desktop-signup">{errors.email.message}</span>}

          {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
            UpdateProfileErrorMessage !== '' &&
            updateUserDetailsuseddata === watchedemail &&
            UpdateProfileErrorMessage?.includes('linked') && (
              <span className="error-Desktop-signup">{UpdateProfileErrorMessage}</span>
            )}
        </div>

        {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
          <div className="domain-buttons">
            {emailDomains.map(domain => (
              <button type="button" key={domain} onClick={() => handleDomainClick(domain)}>
                {domain}
              </button>
            ))}
          </div>
        )}

        {
          <div
            className="button-group-Desktop-signup"
            style={{
              marginTop: restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? '55px' : '0px',
            }}
          >
            <button
              type="button"
              className="cancel-btn-Desktop-signup"
              onClick={() => {
                setCurrentPage('signin');
              }}
            >
              Change
            </button>
            <button type="submit" className="submit-btn-Desktop-signup">
              Continue
            </button>
          </div>
        }
      </form>
    </div>
  );
};

export default DesktopSignupModal;
